



















import {
    computed,
    defineComponent,
    PropType,
    ref,
} from '@vue/composition-api';
import { useThemedLogo } from '@superbet-group/web.lib.ui-components';
import { SdsPaymentLogo } from '@src/config/shell/localConfigTypes';

export default defineComponent({
    name: 'PaymentLogos',
    props: {
        paymentLogos: {
            type: Array as PropType<SdsPaymentLogo[]>,
            required: true,
        },
    },
    setup(props) {
        const themedPaymentLogos = computed(() =>
            props.paymentLogos.map(({ logoName, width }) => {
                const imageUrl = useThemedLogo(ref(logoName));
                return {
                    name: logoName,
                    imageUrl: imageUrl.value,
                    width,
                };
            }),
        );

        return {
            themedPaymentLogos,
        };
    },

});

